import Pochta from "./Pochta";
function INTP()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
          <div className="image-wrapper" >
     <img src="/img/INTP Ученый.png" className="INTP"/>
     </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
         <h2>INTP</h2>
   <p><strong>Процент населения:</strong> 3–5%</p>
<p><strong>Среди мужчин:</strong> 4–6%</p>
<p><strong>Среди женщин:</strong> 1–3%</p>
<p><strong>Стратегия:</strong> Поиск закономерностей</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  INTP черпают энергию в одиночестве и интеллектуальных занятиях. 
  Им нужно время, чтобы обдумать теории и найти закономерности. 
  Они восстанавливают силы, погружаясь в свои мысли.
</p>
<p>
  Решения INTP принимают на основе логики и объективного анализа. 
  Они доверяют фактам, а не эмоциям, и постоянно ищут новые знания. 
  Они ценят интеллект, свободу мысли и оригинальность.
</p>
<p>
  Это любознательные и креативные люди. 
  Они всегда ищут нестандартные решения и новые подходы. 
  Им трудно заниматься рутиной, но их идеи вдохновляют других.
</p>

<p><strong>Особенность:</strong></p>
<p>
  INTP никогда не отключают мозг. Они анализируют всё — даже то, что не нужно. 
  Они могут игнорировать людей, если увлечены идеей, и не замечать, что кого-то обидели. 
  Им сложно выражать эмоции, и они часто кажутся равнодушными. 
  Спорят не чтобы победить, а чтобы понять — и это бесит окружающих.
</p>

<p>
  INTP — человек, который может решить задачу, над которой человечество билось годы, 
  и забыть поесть в процессе. Они собирают знания как другие — марки. Их мозг — это 
  библиотека, где каждая книга открыта одновременно. Они могут быть гениальными 
  и абсолютно беспомощными в быту. И это их очарование.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default INTP;